import { useLocation } from "wouter";
import { useAdminMode } from "../../contexts/AdminModeContext";
import type { PreviewRole } from "../../contexts/AdminModeContext";
import { cn } from "../../lib/utils";

const ROLES: { label: string; role: PreviewRole }[] = [
  { label: "Guest",     role: "guest" },
  { label: "Dancer",    role: "dancer" },
  { label: "Organizer", role: "organizer" },
  { label: "Studio",    role: "studio" },
  { label: "Volunteer", role: "volunteer" },
  { label: "Moderator", role: "moderator" },
];

export function AdminDevToolbar() {
  const { previewRole, setPreviewRole, isPreviewMode } = useAdminMode();
  const [, navigate] = useLocation();

  return (
    <>
      {/* Toolbar strip — desktop only */}
      <div className="hidden sm:flex items-center gap-2 flex-wrap border-t border-yellow-700/40 bg-yellow-950/70 px-4 py-1.5 text-xs">
        <span className="text-yellow-400 font-semibold shrink-0">Preview as:</span>

        {ROLES.map(({ label, role }) => (
          <button
            key={role}
            onClick={() => setPreviewRole(previewRole === role ? null : role)}
            className={cn(
              "px-2 py-0.5 rounded font-medium transition-colors",
              previewRole === role
                ? "bg-yellow-400 text-yellow-950"
                : "bg-yellow-900/50 text-yellow-300 hover:bg-yellow-800"
            )}
          >
            {label}
          </button>
        ))}

        {isPreviewMode && (
          <button
            onClick={() => setPreviewRole(null)}
            className="px-2 py-0.5 rounded bg-red-800/80 text-red-200 hover:bg-red-700 font-medium transition-colors"
          >
            Reset
          </button>
        )}

        <button
          onClick={() => navigate("/onboarding")}
          className="ml-auto px-2 py-0.5 rounded bg-yellow-800/60 text-yellow-200 hover:bg-yellow-700 font-medium transition-colors"
        >
          Show Onboarding
        </button>
      </div>

      {/* Fixed bottom preview banner */}
      {isPreviewMode && (
        <div className="fixed bottom-0 inset-x-0 z-[100] bg-yellow-500 text-yellow-950 text-center text-xs font-bold py-1 pointer-events-none select-none">
          PREVIEW — Viewing as: {previewRole?.toUpperCase()} · No changes will be saved
        </div>
      )}
    </>
  );
}
